import {ThumbDown, ThumbUp, ThumbsUpDown} from '@mui/icons-material';
import {Button, CircularProgress, Paper, Stack, Typography} from '@mui/material';
import {QuizSessionFeedback} from '@cp/model';

export interface SessionCompleteFeedbackProps {
  feedback?: QuizSessionFeedback;
  loading: boolean;
  onSelect: (feedback: QuizSessionFeedback) => void;
}

export default function SessionCompleteFeedback({feedback, loading, onSelect}: SessionCompleteFeedbackProps) {
  const disabled = Boolean(feedback) || loading;

  return (
    <Paper sx={{p: 3}}>
      <Stack spacing={2}>
        <Typography variant="h6" sx={{fontWeight: 600}}>
          How was this session?
        </Typography>
        <Stack direction={{xs: 'column', sm: 'row'}} spacing={1.5}>
          <Button
            onClick={() => onSelect(QuizSessionFeedback.GOOD)}
            disabled={disabled}
            variant={feedback === QuizSessionFeedback.GOOD ? 'contained' : 'outlined'}
            startIcon={<ThumbUp />}
            sx={{color: 'success.main', borderColor: 'success.main'}}
          >
            {loading ? <CircularProgress size={16} color="inherit" sx={{mr: 1}} /> : null}
            Good
          </Button>
          <Button
            onClick={() => onSelect(QuizSessionFeedback.AVERAGE)}
            disabled={disabled}
            variant={feedback === QuizSessionFeedback.AVERAGE ? 'contained' : 'outlined'}
            startIcon={<ThumbsUpDown />}
            sx={{color: 'grey.600', borderColor: 'grey.500'}}
          >
            {loading ? <CircularProgress size={16} color="inherit" sx={{mr: 1}} /> : null}
            Average
          </Button>
          <Button
            onClick={() => onSelect(QuizSessionFeedback.BAD)}
            disabled={disabled}
            variant={feedback === QuizSessionFeedback.BAD ? 'contained' : 'outlined'}
            startIcon={<ThumbDown />}
            sx={{color: 'error.main', borderColor: 'error.main'}}
          >
            {loading ? <CircularProgress size={16} color="inherit" sx={{mr: 1}} /> : null}
            Bad
          </Button>
        </Stack>
      </Stack>
    </Paper>
  );
}
